import CONSTANT from "../../constants/constant";
import MessageModal from "../MessageModal";
import { useSearchParams } from "react-router-dom";
import { useErrorState } from "../../contexts/errorContext";

const ErrorModal = () => {
  const { isError, setIsError } = useErrorState();
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("q");

  const onCloseDialog = (val) => {
    if (val === CONSTANT.CLOSE) {
      if (param) {
        //Clear search param
        searchParams.delete("q");
        setSearchParams(searchParams);
      }

      setIsError(false);
    }
  };
  if (isError) {
    return (
      <MessageModal
        isOpen
        onClose={onCloseDialog}
        title={CONSTANT.ERROR.TITLE}
        message={CONSTANT.ERROR.TECHNICAL_MESSAGE}
      />
    );
  }
};

export default ErrorModal;
